var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"radio",class:{'on': _vm.checked},attrs:{"data-title":_vm.title}},( _obj = {}, _obj[_vm.isTouch ? 'touchstart' : 'click'] = _vm.toggle, _obj )),[_c('div',{staticClass:"radio-check",class:_vm.css},[_c('i',{staticClass:"icon icon-check"})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }